
<template>
  <a id="grupo-do-whatts"></a>
  <section class="grupo-do-whatts">
    <h2>Junte-se ao grupo oficial do WhatsApp do América Rock Bar!</h2>
    <p>
      Receba em primeira mão a <strong>agenda de shows</strong>, <strong>eventos exclusivos</strong>, e conecte-se com a galera do rock e de São Bernardo do Campo e região!
    </p>
    <a href="https://chat.whatsapp.com/EtnUNZ6hiXh2rVad1GPHni?mode=ac_t" target="_blank">
      <img src="../assets/whatsapp-ico.svg"  alt="ícone do whattsapp"/>
      Entrar no grupo do WhatsApp
    </a>
  </section>

</template>


<style scoped>
.grupo-do-whatts {
  background: #111;
  color: #fff;
  padding: 2rem;
  text-align: center;

  p {
    font-size: 1.0rem;
    max-width: 600px;
    margin: 0 auto 20px;
    line-height: 1.8;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #25D366 ;
    color: #25D366 ;
    font-weight: bold;
    padding: 15px 25px;
    font-size: 1.1em;
    border-radius: 8px;
    text-decoration: none;
    width: 18rem;
    margin: 0 auto 20px;
    gap: .5rem;

    &:hover {
      background: rgba(81, 135, 73, 0.2);
    }

    img {
      width: 1.5rem;
    }
  }

}

@media screen and (max-width : 600px) {
  .grupo-do-whatts {
    a {
      width: 80%;
    }
  }
}

@media screen and (max-width : 320px) {
  .grupo-do-whatts {
    a {
      width: auto;
    }
  }
}

</style>

<script setup lang="ts">
</script>